import React from "react";
import Sidebar from "../../commons/Sidebar/Sidebar";
import Header from "../../commons/Header/Header";
import Customer from "./Customer/Customer";
import "notosans-fontface/css/notosans-fontface.css";

function ContentManagementSystem() {
  return (
    <>
      <div className="container-scroller">
        <Header />
        <div className="container-fluid page-body-wrapper">
          <Sidebar status={true} />

          <div className="main-panel">
            <div className="content-wrapper">
              <div className="heading mb-4">
                <h3 className="text-default weight-400">Content Management System</h3>
              </div>
              <div className="row mx-0 main-content-body">
                <Customer />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContentManagementSystem;